import {createBrowserHistory} from 'history';
export { createBrowserHistory };
export const history = createBrowserHistory();